import HeaderController from "../../../components/Headers/HeaderController";
import CarePlusHero from "./components/CarePlusHero";
import CarePlusWhatsNext from "./components/CarePlusWhatsNext";
import CarePlusCrossSell from "./components/CarePlusCrossSell";
import AppInstallBanner from "../../../components/AppInstallBanner/AppInstallBanner";
import { clientConfig } from "../../../config";
import "./CarePlus.css";

const WAVE_DESKTOP = `${clientConfig.IMAGES_URL}redesign_2025/care-plus/questionnaire/blob-desktop/blob-desktop.png`;
const WAVE_MOBILE = `${clientConfig.IMAGES_URL}redesign_2025/care-plus/questionnaire/blob/blob.png`;

const Wave = ({ className }: { className: string }) => (
    <picture>
        <source media="(min-width: 768px)" srcSet={WAVE_DESKTOP} />
        <img src={WAVE_MOBILE} alt="" aria-hidden="true" className={`care-plus-wave ${className}`} />
    </picture>
);

interface ThankyouCarePlusProps {
    customerEmail?: string;
    country?: string;
    language?: string;
    /** Undefined while the pairing answer is still loading, which keeps the banner hidden. */
    isPairedToMobileApp?: boolean;
    /** Placement ids the api allows. Undefined keeps them all hidden. */
    appInstallPlacements?: string[];
    customerUuid?: string;
    orderHash?: string;
}

export default function ThankyouCarePlus({ customerEmail, country, language, isPairedToMobileApp, appInstallPlacements, customerUuid, orderHash }: ThankyouCarePlusProps) {

    return (
        <div className="care-plus-page">
            <Wave className="care-plus-wave--top" />
            <Wave className="care-plus-wave--bottom" />
            <HeaderController language={language} showSteps={false} stage={"Treatment"} />
            <div className="care-plus-body-container">
                <div className="care-plus-container">
                    <CarePlusHero language={language} customerEmail={customerEmail} />
                    <CarePlusWhatsNext language={language} />
                    {/* Care Plus orders land on this layout instead, so it carries the same W1 / W2 banner */}
                    <AppInstallBanner
                        desktopPlacementId="W1"
                        mobilePlacementId="W2"
                        language={language!}
                        country={country}
                        customerUuid={customerUuid}
                        isPairedToMobileApp={isPairedToMobileApp}
                        allowedPlacements={appInstallPlacements}
                        orderHash={orderHash}
                        className="thankyou-app-install-banner"
                    />
                </div>
                <CarePlusCrossSell language={language} country={country} />
            </div>
        </div>
    )
}
